import React from 'react';
import { SideNavigation } from '@amzn/awsui-components-react';
import { useNavigate } from 'react-router-dom'
const items = [
  {
    type: 'link',
    text: 'CPE Submission',
    href: '/'
  },
];


export function Navigation(props) {
  const navigate = useNavigate();

  return (
    <SideNavigation
      header={{ href: "#/", text: "CPE Dashboard" }}
      items={items}
      activeHref={props.activeHref}
      onFollow={(event) => {
        event.preventDefault();
        navigate(event.detail.href);
      }
      }
    />
  );
}